import { render, staticRenderFns } from "./centerRight.vue?vue&type=template&id=4ca04f2b&"
import script from "./centerRight.vue?vue&type=script&lang=js&"
export * from "./centerRight.vue?vue&type=script&lang=js&"
import style0 from "./centerRight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports